<template>
  <li class="order-product">
    <img
      :src="imagePath"
      :alt="itemData.name || 'Item'"
      class="order-product__image"
      @error="tryCatalogDir">
    <div class="order-product__details">
      <div class="order-product__name">
        {{ itemData.name }}
      </div>
      <div class="order-product__price-each">
        {{ itemData.quantity }} @ {{ itemData.unitPrice | price }}/each
      </div>
      <div class="order-product__total-price">
        Total: {{ itemData.quantity * itemData.unitPrice | price }}
      </div>
    </div>
  </li>
</template>

<script>
import api from '../../utils/api';

export default {
  name: 'OrderProduct',
  props: {
    itemSet: String,
    item: Object,
  },
  data() {
    return {
      itemData: {
        /*
        name: '',
        quantity: 0,
        unitPrice: 0,
        */
      },
      imagePath: '',
    };
  },
  computed: {
    hatImageDir() {
      return this.$store.state.hats.imageDir;
    },
    patchImageDir() {
      return this.$store.state.patches.imageDir;
    },
    customsImageDir() {
      return this.$store.state.patches.customsDir;
    },
    patchPrice() {
      return this.$store.state.cart.catalogPatchPrice;
    },
  },
  created() {
    // similar case handling to CartItem.vue
    let itemCase;
    const set = this.itemSet;
    const group = this.item.patchGroup;

    if (set === 'hats') itemCase = 'hat';
    if (set === 'patches' && group === 'catalog') itemCase = 'catalog';
    if (set === 'patches' && group === 'submissions') itemCase = 'submission';
    if (set === 'patches' && group === 'savedCustoms') itemCase = 'savedCustom';
    if (set === 'customs') itemCase = 'custom';

    switch (itemCase) {
      case 'hat':
        this.itemData = {
          name: this.item.name,
          quantity: this.item.quantity,
          unitPrice: this.item.unitPrice,
        };
        api
          .getData(`/hats/${this.item.slug}`)
          .then((res) => {
            const image = res.data.images[0];
            this.imagePath = this.hatImageDir + image;
          });
        break;
      case 'catalog':
        this.itemData = {
          name: this.item.name,
          quantity: this.item.quantity,
          unitPrice: this.item.unitPrice,
        };
        this.imagePath = `${this.patchImageDir + this.item.imageId}.png`;
        break;
      case 'submission':
        this.itemData = {
          name: this.item.name,
          quantity: this.item.quantity,
          unitPrice: this.item.unitPrice,
        };
        this.imagePath = `${this.customsImageDir + this.item.imageId}.png`;
        break;
      case 'savedCustom':
        this.itemData = {
          name: 'custom patch',
          quantity: this.item.quantity,
          unitPrice: this.item.unitPrice,
        };
        this.imagePath = `${this.customsImageDir + this.item.imageId}.png`;
        break;
      case 'custom':
        this.itemData = {
          name: 'custom patch',
          quantity: this.item.quantity,
          unitPrice: this.item.unitPrice,
        };
        this.imagePath = `${this.customsImageDir + this.item.imageId}.png`;
        break;
      default: // if no itemCase, do nothing
        break;
    }
  },
  methods: {
    tryCatalogDir() {
      if (this.itemSet === 'patches') {
        this.imagePath = `${this.patchImageDir + this.item.imageId}.png`;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@require('../../stylus/base')

.order-product
  display: flex
  flex: 1 1 0
  flex-flow: row nowrap
  align-items: center
  justify-content: space-between
  margin: 0
  padding-bottom: $base-padding*.5
  &+.list-item
    padding-top: $base-padding*.5
  &__image
    max-width: 7rem
  &__details
    display: flex
    flex-flow: row wrap
    align-items: flex-start
    justify-content: space-between
    width: 100%
    height: 100%
    padding: $base-padding*.5 $base-padding
  &__name
    width: 100%
    text-transform: capitalize
  &__total-price
    align-self: flex-end
    font-weight: $base-header-font-weight + 100
  &__price-each
    align-self: flex-end
    padding-bottom: $base-padding*.25

</style>
